import {createFileRoute} from '@tanstack/react-router';
import {ConnectedAccountAddPage} from 'pages/service/ConnectedAccountPage/ConnectedAccountAddPage';

export const Route = createFileRoute('/_protected/connected-account/add/')({
  component: ConnectedAccountAddPage,
});
